import { makeStyles } from '@material-ui/core';

import { neutral, teal } from 'shared/styles/colors';

export default makeStyles({
  article: {
    padding: '0.5rem 0.75rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    backgroundColor: teal['20'],
    borderRadius: '0.5rem',
    border: `1px solid ${teal['50']}`,
    cursor: 'pointer',
    fontSize: '1rem',
    animation: '$pulse 1s infinite',
    animationTimingFunction: 'ease-in-out',
    '&[data-has-turbotag="true"]': {
      paddingTop: '1.5rem',
    },
  },
  section: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  detail: {
    alignItems: 'center',
    color: neutral['80'],
    padding: '0.25rem',
    display: 'flex',
    columnGap: '0.5rem',
    fontSize: '0.75rem',
    fontWeight: 600,
  },
  orderInfo: {
    display: 'grid',
    gridAutoFlow: 'row',
    gridAutoRows: 'auto',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  orderId: {
    margin: 0,
    lineHeight: 1.5,
    fontWeight: 'bold',
    wordBreak: 'break-all',
    color: neutral['90'],
  },
  storeName: {
    margin: 0,
    fontSize: '0.75rem',
    fontWeight: 'normal',
    lineHeight: 1.7,
    wordBreak: 'break-word',
    color: neutral['70'],
  },
  turboTag: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  '@keyframes pulse': {
    '0%': {
      transform: 'scale3d(1, 1, 1)',
    },
    '50%': {
      transform: 'scale3d(1.02, 1.02, 1.02)',
    },
    '100%': {
      transform: 'scale3d(1, 1, 1)',
    },
  },
});
